import React from 'react'
import InnerHaeder from '../Component/InnerHaeder'
import Highlights from '../Component/Highlights'
import Footer from'../Component/Footer'
import { Link } from 'react-router-dom'
import HeadTag from '../Component/HeadTags'
const ApplicationForm = () => {
  return (
    <>
    <HeadTag title="Application Form" />
     <Highlights/>
     <InnerHaeder/>
     <div className="inner_page">
       <div className="container-fluid flwidth">
       <div className="bgimage">
        <h5><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link><span> Admission <i className="fas fa-angle-right"></i>  Application Form </span></h5>
        <h2> Application Form</h2>
        </div>
        <div className="row">
           <div className="col-lg-12 col-md-12">
              <iframe src="https://webapi.entab.info/api/image/LVISGN/public/pdf/application-form.pdf" width="100%" height="800px"></iframe>
           </div>
        </div>
        </div>
        </div>
     <Footer/>
    </>
  )
}

export default ApplicationForm
